import { SRGBColorSpace } from 'three'
import { installHtmlInCanvasPolyfill } from 'three-html-render/polyfill'
import { ThreeHTMLRenderer } from 'three-html-render/renderer'

let polyfillInstalled = false

export class HtmlScreen {
    constructor(canvas, { content = null, contentSelector = '.screen-content' } = {}) {
        this.canvas = canvas

        this.content = content || canvas.querySelector(contentSelector)
        if (!this.content) {
            throw new Error(`HtmlScreen: no content element (${contentSelector}) found inside the canvas`)
        }

        if (!polyfillInstalled) {
            installHtmlInCanvasPolyfill()
            polyfillInstalled = true
        }

        this.htmlRenderer = new ThreeHTMLRenderer()
        this.attached = false
        this._colorSpaceSet = false
        this._lastPaint = 0
        this.paintIntervalMs = 100 // ~10 fps texture refresh
    }

    connect(camera, threeRenderer) {
        this.htmlRenderer.connect(this.canvas, camera, threeRenderer)
    }

    attach(mesh) {
        if (this.attached) return
        this.htmlRenderer.addObject(this.content, mesh)
        this.attached = true
    }

    update() {
        // Throttle the expensive bit: requestPaint re-serializes the whole
        // DOM subtree to SVG every call. The cheap overlay positioning still
        // runs every frame so clicks/hover stay in sync with the mesh.
        const now = performance.now()
        if (now - this._lastPaint >= this.paintIntervalMs) {
            this.canvas.requestPaint()
            this._lastPaint = now
        }
        this.htmlRenderer.overlayRenderer.update()

        if (!this._colorSpaceSet) {
            const tex = this.htmlRenderer.getTexture(this.content)
            if (tex) {
                tex.colorSpace = SRGBColorSpace
                tex.needsUpdate = true
                this._colorSpaceSet = true
            }
        }
    }

    setSection(section) {
        const el = this.content.querySelector('.section-indicator')
        if (el) el.textContent = `Section ${section}`
    }
}
